// unit cost 
const MATERIAL_UC = [5.8, 6.1, 7.9, 12.7, 17.5];
const MANUFACTURING_UC = [4.4, 5.1, 6.0, 10.2, 15.7];
const FEATURES_UC = [0, 9, 11, 7, 8, 14, 18, 2, 3, 1];

//investments
const MATERIAL_I = [50, 70, 90, 140, 200];
const MANUFACTURING_I = [190, 250, 370, 480, 600];
const DESIGN_I = [700, 770, 860, 1090, 1290];
const FEATURES_I = [0, 100, 120, 220, 210, 190, 300, 30, 40, 0];

//R&D time
const MATERIAL_T = [0.5, 0.5, 0.5, 0.5, 0.5];
const MANUFACTURING_T = [0.5, 1, 1.5, 2, 2.5];
const DESIGN_T = [1.5, 2, 2.5, 3, 3.5];
const FEATURES_T = [0, 1, 1.5, 1, 1.5, 2, 2, 1, 2, 0];

export function UnitCost(mat, man, v, feature = 0) {
    const res =  MATERIAL_UC[mat - 1] + MANUFACTURING_UC[man - 1] +
    + FEATURES_UC[feature] + (MANUFACTURING_UC[man - 1] * 0.2 * v);

    return parseFloat(res.toFixed(2))
}

export function Investments(mat, man, v, design, feature = 0) {
    const res =  DESIGN_I[design - 1] + MATERIAL_I[mat - 1] + MANUFACTURING_I[man - 1] +
    + FEATURES_I[feature] + (DESIGN_I[design - 1] * 0.2 * v);
    
    return parseFloat(res.toFixed(2))
}

export function UpgradeInvestments(mat, man, v, design, mat2, man2, v2, feature2 = 0) {
    
    const res =  Math.abs(MATERIAL_I[mat2 - 1] - MATERIAL_I[mat - 1]) + 
    Math.abs(MANUFACTURING_I[man2 - 1] - MANUFACTURING_I[man - 1]) +
    + FEATURES_I[feature2] + 
    + Math.abs(DESIGN_I[design - 1] * 0.2 * (v2 - v));
    
    return parseFloat(res.toFixed(2))
}

export function AvailabilityFrom(mat, man, v, design, feature = 0) {
    const res = DESIGN_T[design - 1] + MANUFACTURING_T[man - 1] + 
    + MATERIAL_T[mat - 1] + FEATURES_T[feature] +
    + (0.5 * v);
    
    return Math.ceil(res);
}

export function UpgradeAvailabilityFrom(mat, man, v_prev, v, feature = 0) {
    const res = MANUFACTURING_T[man - 1] + 
    + MATERIAL_T[mat - 1] + FEATURES_T[feature] +
    + (0.2 * Math.abs(v - v_prev) / v);
    
    return Math.ceil(res);
}


